export default "__VITE_ASSET__BORVyF_o__"